import { FounderQuote } from "@/components/FounderQuote";

export const EmailBlacklistsFounderQuote = () => (
  <FounderQuote
    author="aman"
    quote="The biggest mistake I see is treating every blacklist alert as an emergency. The right response starts with knowing who actually reads that list. Most of the panic in this industry comes from alerts that affect nobody."
    tagline="Writing on email infrastructure, reputation systems and deliverability"
  />
);